import { ICollection, ITag } from '@ml/common';

export class CollectionVM implements ICollection {
  CollectionId: number;
  Title: string;
  ImageFileName: string;
  Description: string;
  ParentCollectionId: number | null;
  CommunityId: number;
  CreatedOn: string;
  ModifiedOn: string;
  VirtualDirectory: string;
  FloorPlanIds: number[] = [];
  TagIds: number[] = [];
  Tags: ITag[] = [];

  ImageUrl: string;

  constructor(data?: ICollection, baseUrl?: string) {
    Object.assign(this, data);

    if (baseUrl && this.ImageFileName) {
      this.ImageUrl = `${baseUrl}/Collections/${this.ImageFileName}`;
    }
  }
}
